module.exports = __webpack_public_path__ + "img/SB icon.b6e0db54.svg";